import { Box, Button, Typography, useTheme } from "@mui/material";
import TooltipWrapper from "../../components/TooltipWrapper";

/**
 * Demo component for TooltipWrapper
 * Shows usage example of the TooltipWrapper component with formatted content
 */
const TooltipWrapperDemo = () => {
  const theme = useTheme();
  return (
    <Box>
      <TooltipWrapper
        name="example-tooltip"
        content={
          <Box p={1}>
            <Typography variant="subtitle2">Detailed Information</Typography>
            <Typography variant="body2">
              This is a more complex tooltip with formatted content.
            </Typography>
          </Box>
        }
        style={{ borderTop: `2px solid ${theme.palette.primary.main}` }}
      >
        <Button variant="outlined" size="small" sx={{ borderRadius: 2 }}>
          Hover for details
        </Button>
      </TooltipWrapper>
    </Box>
  );
};

export default TooltipWrapperDemo;
